export const ApiDef_DeletedDoc = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map